module.exports = __webpack_public_path__ + "img/logo.7f8d10fa.png";